App.Models.user = class User extends PF.Model
	{

	init()
		{
		super.init();

		this.calc('fio', ['fname', 'mname', 'lname'], () => Util.fio(this));
		this.calc('phoneFormat', ['phone'], (phone) => Util.phoneMediator(phone));
		}


	};

